import React from "react";
import { getAvatarColor } from "utils/avatarColor";
import { getInitials } from "components/common/UserAvatar";
import { ROLE_LABEL_MAP, UserRole } from "types/users";

const formatRole = (role: string): string =>
  ROLE_LABEL_MAP[role as UserRole] || role;

export interface SuggestedItem {
  id: string;
  name: string;
  subtitle?: string;
  imageUrl?: string | null;
  roles?: string[];
}

interface SuggestedMemberProps {
  item: SuggestedItem;
  onSelect: (item: SuggestedItem) => void;
  isSelected: boolean;
  leading?: React.ReactNode;
}


const SuggestedMember: React.FC<SuggestedMemberProps> = ({
  item,
  onSelect,
  isSelected,
  leading,
}) => {
  const initials = getInitials(item.name || "?");

  return (
    <div className="flex items-center justify-between p-3 hover:bg-primary-light rounded-lg transition-colors">
      <div className="flex items-center gap-3 min-w-0">
        {leading ? (
          leading
        ) : item.imageUrl ? (
          <img
            src={item.imageUrl}
            alt={item.name}
            className="w-8 h-8 rounded-full object-cover shrink-0"
          />
        ) : (
          <div
            className={`w-8 h-8 rounded-full flex items-center justify-center text-white text-sm font-medium shrink-0 ${
              getAvatarColor(item.name || "").bg
            }`}
          >
            {initials}
          </div>
        )}

        <div className="min-w-0">
          <p className="text-sm font-medium text-neutral truncate">{item.name}</p>
          {item.subtitle && (
            <p className="text-xs text-neutral-medium truncate">{item.subtitle}</p>
          )}
          {item.roles && item.roles.length > 0 && (
            <div className="mt-1 flex flex-wrap gap-1">
              {item.roles.map((role) => (
                <span
                  key={role}
                  className="px-2 py-1 rounded-full text-[10px] bg-[#6B728033] text-[#9CA3AF] border-gray-200"
                >
                  {formatRole(role)}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>

      <button
        type="button"
        onClick={() => onSelect(item)}
        disabled={isSelected}
        className={`shrink-0 text-sm px-3 py-1 rounded transition-colors ${
          isSelected
            ? "bg-blue-500 text-white cursor-default"
            : "bg-[#252B3B] text-[#9CA3AF] hover:bg-blue-500 hover:text-white"
        }`}
      >
        {isSelected ? "Selected" : "Select"}
      </button>
    </div>
  );
};

export default SuggestedMember;
